/**
 * Shared Date-Formatting Utilities fuer Protokoller Agent
 * Alle Formate: de-CH Locale
 */

/** Parse DB timestamp (UTC without Z suffix) into proper Date */
function parseDate(dateStr) {
  if (!dateStr) return null
  const d = new Date(typeof dateStr === 'string' && !dateStr.endsWith('Z') && !dateStr.includes('+') ? dateStr + 'Z' : dateStr)
  if (isNaN(d.getTime()) || d.getFullYear() < 2000) return null
  return d
}

/**
 * Relative Datumsanzeige (wie Apple Mail): Uhrzeit / Gestern / Mo / 14.02.25
 */
export function formatRelativeDate(dateStr) {
  const d = parseDate(dateStr)
  if (!d) return dateStr ? String(dateStr) : ''
  const now = new Date()
  // Nach Kalendertagen vergleichen (Mitternacht zu Mitternacht), nicht nach
  // verstrichenen 24h-Fenstern — sonst zeigt eine Sonntag-Mail am Dienstag "Gestern".
  const startOfDay = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate())
  const diffDays = Math.round((startOfDay(now) - startOfDay(d)) / (1000 * 60 * 60 * 24))

  if (diffDays === 0) return d.toLocaleTimeString('de-CH', { hour: '2-digit', minute: '2-digit' })
  if (diffDays === 1) return 'Gestern'
  if (diffDays < 7) return d.toLocaleDateString('de-CH', { weekday: 'short' })
  return d.toLocaleDateString('de-CH', { day: '2-digit', month: '2-digit', year: '2-digit' })
}

/**
 * Kurzes Datum: 14.02.26
 */
export function formatShortDate(dateStr) {
  const d = parseDate(dateStr)
  if (!d) return dateStr ? String(dateStr) : ''
  return d.toLocaleDateString('de-CH', { day: '2-digit', month: '2-digit', year: '2-digit' })
}

/**
 * Datum mit Uhrzeit: 14.02.2026, 09:30
 */
export function formatDateTime(dateStr) {
  const d = parseDate(dateStr)
  if (!d) return dateStr ? String(dateStr) : ''
  return d.toLocaleDateString('de-CH', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
  })
}
